var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DatasetAsImage',{attrs:{"path":_vm.args.path,"history_dataset_id":_vm.args.history_dataset_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }